import { render, staticRenderFns } from "./WGList.vue?vue&type=template&id=f13d7ae4&scoped=true&"
import script from "./WGList.vue?vue&type=script&lang=js&"
export * from "./WGList.vue?vue&type=script&lang=js&"
import style0 from "./WGList.vue?vue&type=style&index=0&id=f13d7ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../food/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13d7ae4",
  null
  
)

export default component.exports